import { forwardRef } from 'react';

type Props = React.SVGAttributes<SVGSVGElement>;
type Ref = SVGSVGElement;

const InfoRounded = forwardRef<Ref, Props>((props, ref) => (
    <svg
        ref={ref}
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <g opacity='0.5'>
            <path
                d='M8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0ZM8 14.4C4.4712 14.4 1.6 11.5288 1.6 8C1.6 4.4712 4.4712 1.6 8 1.6C11.5288 1.6 14.4 4.4712 14.4 8C14.4 11.5288 11.5288 14.4 8 14.4Z'
                fill='#F8F8F8'
                fillOpacity='0.8'
            />
            <path
                d='M7 7.2H9V12H7V7.2ZM7 4H9V5.6H7V4Z'
                fill='#F8F8F8'
                fillOpacity='0.8'
            />
        </g>
    </svg>
));

export default InfoRounded;
